"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "icon": "tcl__Icon-0f24ac4b",
  "size-18": "tcl__Icon-ed34b65f",
  "size-24": "tcl__Icon-abe5c41a",
  "size-36": "tcl__Icon-d36d27ae",
  "size-48": "tcl__Icon-bded2535",
  "color-inherit": "tcl__Icon-5a761f52",
  "color-black": "tcl__Icon-c0cefc1d",
  "color-white": "tcl__Icon-580c6f4a",
  "color-grey": "tcl__Icon-0c4d990e",
  "color-light-grey": "tcl__Icon-3cc69962",
  "color-teal": "tcl__Icon-66ec11f0",
  "color-dark-teal": "tcl__Icon-8475cee7",
  "color-green": "tcl__Icon-2a0fbad3",
  "color-orange": "tcl__Icon-9797e60e",
  "color-red": "tcl__Icon-8e801023"
};
/**
 * A wrapper around Google's [Material Icons](https://material.io/tools/icons/) icons with
 * a few niceties for easier usage within our design system.
 */

const Icon = ({
  name,
  size,
  color,
  title,
  ariaHidden,
  ...props
}) => {
  const className = (0, _classnames.default)(props.className, styles.icon, {
    [styles[`size-${size}`]]: size,
    [styles[`color-${color}`]]: color
  });
  return /*#__PURE__*/_react.default.createElement("i", _extends({}, props, {
    className: className,
    title: title,
    "aria-hidden": ariaHidden
  }), name);
};

exports.Icon = Icon;
Icon.displayName = "Icon";
Icon.propTypes = { ..._withSpacing.propTypes,

  /**
   * Any additional css classes.
   */
  className: _propTypes.default.string,

  /**
   * The icon you'd like to use. For a list of all available icons, please check the [Material Icons documentation](https://material.io/tools/icons/).
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Icon size in px.
   */
  size: _propTypes.default.oneOf([18, 24, 36, 48]),

  /**
   * Predefined icon color. By default it inherits from parent.
   */
  color: _propTypes.default.oneOf(['black', 'white', 'grey', 'light-grey', 'teal', 'dark-teal', 'green', 'orange', 'red', 'inherit']),

  /**
   * Additional information about the icon, for accessibility.
   */
  title: _propTypes.default.string,

  /**
   * If screen readers should ignore the element, for accessibility.
   */
  ariaHidden: _propTypes.default.bool
};
Icon.defaultProps = {
  className: '',
  size: 24,
  ariaHidden: true,
  title: '',
  color: 'inherit'
};

var _default = (0, _withSpacing.default)(Icon);

exports.default = _default;